import React, { Component } from 'react';
import { listPlans, createPlan, updatePlan, DIAS_SEMANA, diasDelPlan, textoBeneficios } from '../utils/membershipsApi';

// Los beneficios del plan: acceso a las jornadas del club y los días con mesa sin entrada.
function BeneficiosEditor({ clubAccess, days, onChange, small }) {
    const set = new Set(days);
    const toggle = (d) => {
        const next = new Set(set);
        if (next.has(d)) next.delete(d); else next.add(d);
        onChange({ clubAccess, days: [...next] });
    };
    return (
        <div style={{ fontSize: small ? 12 : 13 }}>
            <label className="mb-1 d-flex align-items-center" style={{ gap: 6, cursor: 'pointer' }}>
                <input type="checkbox" checked={clubAccess} onChange={(e) => onChange({ clubAccess: e.target.checked, days })} />
                Entrada de socio a las jornadas del club
            </label>
            <div className="d-flex align-items-center flex-wrap" style={{ gap: 4 }}>
                <span className="text-muted mr-1">Mesa sin entrada:</span>
                {DIAS_SEMANA.map((x) => (
                    <button key={x.d} type="button" title={x.largo}
                        className={`btn btn-sm ${set.has(x.d) ? 'btn-accent' : 'btn-white'}`}
                        style={{ padding: '1px 7px', minWidth: 26 }}
                        onClick={() => toggle(x.d)}>{x.corto}</button>
                ))}
                <button type="button" className="btn btn-link btn-sm p-0 ml-1" style={{ fontSize: 12 }}
                    onClick={() => onChange({ clubAccess, days: [1, 2, 3, 4, 5] })}>L a V</button>
            </div>
        </div>
    );
}

const beneficiosPayload = (b) => ({ clubAccess: b.clubAccess, freeTableWeekdays: [...b.days].sort().join('') });

// Configuraciones → Membresías: los planes que se venden en el mostrador (nombre, precio,
// duración en meses, y sus beneficios: club y mesa sin entrada). Cambiar precio o duración aplica sólo a ventas futuras: cada membresía
// guarda su snapshot. Dar de baja un plan lo saca del selector de venta sin tocar a los socios.
class MembershipPlansSettingsComponent extends Component {

    constructor() {
        super();
        this.state = {
            loading: true,
            plans: [],
            error: null,
            nuevo: { name: '', price: '', durationMonths: 1, description: '', clubAccess: true, days: [] },
            editando: null, // { id, name, price, durationMonths, description, clubAccess, days }
            saving: false,
        };
    }

    componentDidMount() {
        this.load();
    }

    load = async () => {
        this.setState({ loading: true, error: null });
        try {
            const data = await listPlans({ includeInactive: true });
            this.setState({ plans: (data && data.plans) || [], loading: false });
        } catch (e) {
            this.setState({ error: e.message, loading: false });
        }
    }

    crear = async () => {
        const n = this.state.nuevo;
        if (!n.name.trim()) { this.setState({ error: 'El plan necesita un nombre.' }); return; }
        this.setState({ saving: true, error: null });
        try {
            await createPlan({ name: n.name.trim(), price: n.price, durationMonths: n.durationMonths, description: n.description.trim() || undefined, ...beneficiosPayload(n) });
            this.setState({ nuevo: { name: '', price: '', durationMonths: 1, description: '', clubAccess: true, days: [] }, saving: false }, this.load);
        } catch (e) {
            this.setState({ error: e.message, saving: false });
        }
    }

    guardar = async () => {
        const ed = this.state.editando;
        this.setState({ saving: true, error: null });
        try {
            await updatePlan(ed.id, { name: ed.name.trim(), price: ed.price, durationMonths: ed.durationMonths, description: ed.description.trim() || null, ...beneficiosPayload(ed) });
            this.setState({ editando: null, saving: false }, this.load);
        } catch (e) {
            this.setState({ error: e.message, saving: false });
        }
    }

    toggleActivo = async (plan) => {
        try {
            await updatePlan(plan.id, { active: !plan.active });
            this.load();
        } catch (e) {
            this.setState({ error: e.message });
        }
    }

    campoNuevo = (k, v) => this.setState({ nuevo: { ...this.state.nuevo, [k]: v }, error: null })
    campoEdit = (k, v) => this.setState({ editando: { ...this.state.editando, [k]: v }, error: null })

    renderFila = (p) => {
        const ed = this.state.editando;
        if (ed && ed.id === p.id) {
            return (
                <tr key={p.id}>
                    <td><input type="text" className="form-control form-control-sm" value={ed.name} onChange={(e) => this.campoEdit('name', e.target.value)} /></td>
                    <td><input type="number" className="form-control form-control-sm" min="0" step="1" value={ed.price} onChange={(e) => this.campoEdit('price', e.target.value)} /></td>
                    <td><input type="number" className="form-control form-control-sm" min="1" max="36" value={ed.durationMonths} onChange={(e) => this.campoEdit('durationMonths', e.target.value)} /></td>
                    <td>
                        <input type="text" className="form-control form-control-sm mb-1" value={ed.description} onChange={(e) => this.campoEdit('description', e.target.value)} />
                        <BeneficiosEditor small clubAccess={ed.clubAccess} days={ed.days}
                            onChange={(b) => this.setState({ editando: { ...ed, ...b }, error: null })} />
                    </td>
                    <td>{p.active ? 'Activo' : 'De baja'}</td>
                    <td className="text-right text-nowrap">
                        <button type="button" className="btn btn-sm btn-accent" disabled={this.state.saving} onClick={this.guardar}>Guardar</button>
                        <button type="button" className="btn btn-sm btn-white ml-2" onClick={() => this.setState({ editando: null })}>Cancelar</button>
                    </td>
                </tr>
            );
        }
        return (
            <tr key={p.id} style={{ opacity: p.active ? 1 : 0.6 }}>
                <td>{p.name}</td>
                <td>${Number(p.price)}</td>
                <td>{p.duration_months === 1 ? '1 mes' : `${p.duration_months} meses`}</td>
                <td>
                    <div className="text-muted">{p.description || '—'}</div>
                    <small>{textoBeneficios(p)}</small>
                </td>
                <td>{p.active ? <span className="badge badge-success">Activo</span> : <span className="badge badge-secondary">De baja</span>}</td>
                <td className="text-right text-nowrap">
                    <button type="button" className="btn btn-sm btn-white"
                        onClick={() => this.setState({ editando: { id: p.id, name: p.name, price: Number(p.price), durationMonths: p.duration_months, description: p.description || '', clubAccess: Number(p.club_access) !== 0, days: diasDelPlan(p.free_table_weekdays) } })}>
                        Editar
                    </button>
                    <button type="button" className={`btn btn-sm ml-2 ${p.active ? 'btn-outline-danger' : 'btn-outline-success'}`} onClick={() => this.toggleActivo(p)}>
                        {p.active ? 'Dar de baja' : 'Reactivar'}
                    </button>
                </td>
            </tr>
        );
    }

    render() {
        const n = this.state.nuevo;
        return (
            <div className="card card-small mb-4">
                <div className="card-header border-bottom">
                    <h6 className="m-0">Membresías — planes</h6>
                    <small className="text-muted">Lo que se cobra, por cuánto tiempo y qué incluye. Precio y duración aplican a las ventas nuevas; los beneficios (club, días de mesa sin entrada) aplican a todos los socios del plan desde que se guardan.</small>
                </div>
                <div className="card-body">
                    {this.state.error ? (
                        <div style={{ background: '#FDECEA', color: '#8B2A20', borderRadius: '.25rem', padding: '8px 10px', fontSize: 13, marginBottom: 12 }}>
                            {this.state.error}
                        </div>
                    ) : null}
                    <table className="table table-sm mb-4">
                        <thead>
                            <tr>
                                <th style={{ width: '24%' }}>Plan</th>
                                <th style={{ width: '12%' }}>Precio</th>
                                <th style={{ width: '12%' }}>Duración</th>
                                <th>Descripción y beneficios</th>
                                <th style={{ width: '10%' }}>Estado</th>
                                <th style={{ width: '18%' }}></th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.state.loading ? (
                                <tr><td colSpan="6" className="text-center text-muted">Cargando…</td></tr>
                            ) : this.state.plans.length ? this.state.plans.map(this.renderFila) : (
                                <tr><td colSpan="6" className="text-center text-muted">Todavía no hay planes. Cargá el primero acá abajo.</td></tr>
                            )}
                        </tbody>
                    </table>

                    <h6>Nuevo plan</h6>
                    <div className="row">
                        <div className="col-md-4 form-group">
                            <label>Nombre *</label>
                            <input type="text" className="form-control" placeholder="Socio mensual" value={n.name} onChange={(e) => this.campoNuevo('name', e.target.value)} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label>Precio *</label>
                            <input type="number" className="form-control" min="0" step="1" value={n.price} onChange={(e) => this.campoNuevo('price', e.target.value)} />
                        </div>
                        <div className="col-md-2 form-group">
                            <label>Meses *</label>
                            <input type="number" className="form-control" min="1" max="36" value={n.durationMonths} onChange={(e) => this.campoNuevo('durationMonths', e.target.value)} />
                        </div>
                        <div className="col-md-4 form-group">
                            <label>Descripción</label>
                            <input type="text" className="form-control" placeholder="Entrada libre a las jornadas del club" value={n.description} onChange={(e) => this.campoNuevo('description', e.target.value)} />
                        </div>
                    </div>
                    <div className="mb-3">
                        <BeneficiosEditor clubAccess={n.clubAccess} days={n.days}
                            onChange={(b) => this.setState({ nuevo: { ...n, ...b }, error: null })} />
                    </div>
                    <button type="button" className="btn btn-accent" disabled={this.state.saving} onClick={this.crear}>
                        {this.state.saving ? 'Guardando…' : 'Agregar plan'}
                    </button>
                </div>
            </div>
        );
    }
}

export default MembershipPlansSettingsComponent;
